import React, { useContext, useState, useRef, useEffect } from 'react'
import StateContext from '../context/state/StateContext';
import UserContext from '../context/user/UserContext';
import RadioButton from './RadioButton';
import styles from '../styles/filter.module.css'
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "./ui/select"
import { IoSearch } from "react-icons/io5";
import Fuse from "fuse.js";
import { IoClose } from "react-icons/io5";
import { toast } from 'react-toastify';
import axios from 'axios';
import { useLocation, useNavigate } from "react-router-dom";



const Filter = ({ tickets, allTickets }) => {


    const { user, getTickets } = useContext(UserContext)
    const { setModal, token, setTickets, setCurrentPage, sortOrder, setSortOrder, filterItem, setFilterItem, 
        fromDate, setFromDate, toDate, setToDate, sortBy, setSortBy, filters, setFilters, 
        filter, setFilter, searchValue, setSearchValue, by_search, setBy_search, me_search, setMe_search, employees } = useContext(StateContext)
    const [drop, setDrop] = useState(false);
    const [secondDrop, setSecondDrop] = useState(false);
    const searchInputRef = useRef(null);
    const [searchOpen, setSearchOpen] = useState(false);
    const [category, setCategory] = useState([]);
    
    
    const navigate = useNavigate();
    const location = useLocation()

  
    const formatDate = (dateString) => {
        const options = { year: '2-digit', month: 'long', day: 'numeric' };
        const date = new Date(dateString);
        return date.toLocaleDateString(undefined, options);
    };

    const handleSetFilter = (key) => {
        setFilter(key);
        setSecondDrop(true);
    };



    const fetchCategory = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}api/ticket/getCategory`, {
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': `${token}`,
                },
            });   

            const json = response.data;
            if(json.success){
                const data = [
                    ...new Set(json.category.map(item => item.category))  // Trim and normalize case
                ];
                setCategory(data)
            } else {
                toast.error(json.error || json.message);
            }
        } catch (error) {
            console.log(error);
            toast.error(error.error || error.message);
        }
    }

    useEffect(() => {
        fetchCategory()
        // handleChangeFilter("assigned_to","To me")
    }, [])    

    const assigned_to = ['By me', 'To me'];
    const client_name = [...new Set(tickets.map(item => item.client_name))];
    const status = ["completed", "in progress", "generated", "expired"];

    const handleChangeFilter = (key, value) => {
        setFilters(prevFilters => {
            const updatedFilters = { ...prevFilters };
    
            // Ensure the key exists and is an array
            if (!Array.isArray(updatedFilters[key])) {
                updatedFilters[key] = [];
            }
    
            // Toggle the value in the array
            if (updatedFilters[key].includes(value)) {
                updatedFilters[key] = updatedFilters[key].filter(item => item !== value);
            } else {
                updatedFilters[key].push(value);
            }
    
            // If the key's array is empty after removal, delete the key
            if (updatedFilters[key].length === 0) {
                delete updatedFilters[key];
            }
    
            return updatedFilters;
        });
    };

    const isDateRange = (str) => {
        const dateRangeRegex = /^[A-Za-z]+\s\d{1,2},\s\d{2}\sto\s[A-Za-z]+\s\d{1,2},\s\d{2}$/;
        return dateRangeRegex.test(str);
    };

    // Function to handle the key combination
    const handleKeyDown = (event) => {
        if (event.ctrlKey && event.key === "/") {
            event.preventDefault(); // Prevent the browser's default find behavior
            setSearchOpen(true)
            searchInputRef.current?.focus(); // Focus on the search input
        }
    };

    // Attach event listener to the window
    useEffect(() => {
        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown); // Cleanup listener on unmount
    }, []);

    useEffect(() => {
        if(searchValue){
            setSearchOpen(true)
        }
    }, [searchValue])

    const filterRef = useRef(null)

    useEffect(() => {
        const handleClickOutside = (event) => {
          if (filterRef.current && !filterRef.current.contains(event.target)) {
            setDrop(false); // Close when clicking outside
          }
        };
    
        // Add event listener to document
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
          // Clean up event listener
          document.removeEventListener('mousedown', handleClickOutside);
        };
      }, []);

    const handleCancelFilter = () => {
        setFilter('');
        setFilters([])
        setSecondDrop(false);
        setFromDate('')
        setToDate('')
    }


    const handleApplyFilter = (newFilters, fromDate, toDate, sortBy, sortOrder) => {
        setDrop(false);
        const currentParams = new URLSearchParams(window.location.search);
        if(newFilters){
            const filterParams = JSON.stringify(newFilters); // Convert filters to JSON string
            currentParams.set("filters", filterParams); // Store filters as JSON in the URL
        } else {
            currentParams.delete("filters");
        }
        if(fromDate && toDate){
            currentParams.set("fromDate", fromDate);
            currentParams.set("toDate", toDate);
        } else {
            currentParams.delete("fromDate");
            currentParams.delete("toDate");
        }
        currentParams.delete("page")
        currentParams.set("sort", sortBy);
        currentParams.set("order", sortOrder);
        if(by_search){
            currentParams.set("byMe", by_search)
        }
        if(me_search){
        currentParams.set("toMe", me_search)
        }
        navigate(`?${currentParams.toString()}`);        
        // getTickets(1, newFilters, fromDate, toDate);
    };

    const deleteFilter = (index) => {

        const prevFilters = { ...filters };
        if (!prevFilters) return {};
        const newFilters = { ...prevFilters };
        const filterToRemove = filterItem[index];
        if (!filterToRemove) return prevFilters; // Prevent errors

        const { key, value } = filterToRemove;

        if (key === "deadline") {
            setFromDate('');
            setToDate('');
        } else {
            if (newFilters[key]?.length === 0 || newFilters[key]?.length === 1) {
                delete newFilters[key]; // Remove empty key
            } else {
                newFilters[key] = newFilters[key].filter(item => item !== value);
            }
        }

        if(key === "deadline"){
            handleApplyFilter(newFilters, null, null, sortBy, sortOrder); // Reapply remaining filters
        } else {
            handleApplyFilter(newFilters, fromDate, toDate, sortBy, sortOrder); // Reapply remaining filters
        }
    };

    const handleApply = (sort = sortBy, order = sortOrder) => {
        console.log(filter,filters)
        handleApplyFilter(filters, fromDate, toDate, sort, order);
    }

    const fuse = new Fuse(allTickets, {
        keys: ["title", "category", "description", "id"],
        threshold: 0.3,
        includeScore: true,
    })

    const handleSearch = (value) => {
        setSearchValue(value)
    }

   
    const handleSubmit = (e) => {
        e.preventDefault();
        let value = searchValue
        try {
            if (value.trim()) {
                const result = fuse.search(value)
                setSearchValue(value);
                const currentParams = new URLSearchParams(window.location.search);
                currentParams.set("search", value);
                currentParams.delete("page")
                navigate(`?${currentParams.toString()}`);        
            } else {
                // setTickets(allTickets)
            }
            setFilter('');
            setFilters({});
            setFilterItem([]);
            setCurrentPage(1)
        } catch (e) {
            console.log(e);
        }
    }

    const handleSearchOpen = (open) => {
        setSearchOpen(open);
    
        if (open) {
            setSearchValue('');
            searchInputRef.current?.focus(); // Focus on the search input
        } else {
            const currentParams = new URLSearchParams(window.location.search);
            currentParams.delete("search");
            navigate(`?${currentParams.toString()}`);
        }
    };

    
    

    return (
        <div className='d-flex flex-column align-items-start'>
            <div className="filter-section">
                <form onSubmit={handleSubmit} className={`search ${searchOpen ? 'active' : ''}`}>
                    <input type="text" value={searchValue} ref={searchInputRef} onChange={(e) => { handleSearch(e.target.value) }} placeholder="Search..." />
                    <button data-toggle="tooltip" data-placement="bottom" title="Ctrl + /" className="icon" type="button" onClick={() => {handleSearchOpen(!searchOpen)}}>
                        {searchOpen ? <IoClose /> : <IoSearch  />}
                    </button>
                </form>
                <div></div>
                <div className="filter-drop" ref={filterRef}>
                    <div className={`select mb-0 ${drop ? 'active' : null}`} onClick={() => { setDrop(!drop) }}>Add Filter <i className=' fa-solid fa-plus'></i></div>
                    <div className={`drop-section ${drop ? 'active' : null}`}>
                        <ul className='section-1'>
                            <li className={filter == "Category" ? 'active' : ''} onClick={() => handleSetFilter("Category")}>Category</li>
                            {user.role != "employee" ? <li className={filter == "Assigned_to" ? 'active' : ''} onClick={() => handleSetFilter("Assigned_to")}>Assigned</li> : null}
                            <li className={filter == "Deadline" ? 'active' : ''} onClick={() => handleSetFilter("Deadline")}>Deadline</li>
                            <li className={filter == "Status" ? 'active' : ''} onClick={() => handleSetFilter("Status")}>Status</li>
                        </ul>
                        <div className={`section-2 ${secondDrop ? 'active' : null}`}>
                            <div className={`section-2-scroll ${filter && filter !== "Category" && '!overflow-visible'}`}>
                                {filter == "Category" && category.map((item, index) => {
                                    return <RadioButton keyValue={"category"} index={index} item={item} filters={filters} handleChangeFilter={handleChangeFilter} />
                                })}
                                {filter == "Client_Name" && client_name.map((item, index) => {
                                    return <RadioButton keyValue="client_name" index={index} item={item} filters={filters} handleChangeFilter={handleChangeFilter} />
                                })}
                                {filter == "Assigned_to" && assigned_to.map((item, index) => {
                                    return <RadioButton by_search={by_search} me_search={me_search} setBy_search={setBy_search} setMe_search={setMe_search} keyValue={"assigned_to"} index={index} item={item} filters={filters} handleChangeFilter={handleChangeFilter} employees={employees} />

                                })}
                                {filter == "Deadline" && <div className='px-3'>
                                    <label htmlFor="" className='label'>From</label>
                                    <div className="inputField">
                                        <input type="date" value={fromDate} onChange={(e) => { setFromDate(e.target.value) }} placeholder='Enter a Date' />
                                    </div>
                                    <label htmlFor="" className='label'>To</label>
                                    <div className="inputField">
                                        <input type="date" value={toDate} min={fromDate} onChange={(e) => { setToDate(e.target.value) }} placeholder='Enter a Date' />
                                    </div>
                                </div>
                                }
                                {filter == "Status" && status.map((item, index) => {
                                    return <RadioButton keyValue="status" index={index} item={item} filters={filters} handleChangeFilter={handleChangeFilter} />
                                })}
                            </div>
                            <div className="row px-2 mt-3">
                                <div className="col-4">
                                    <button className='cancel' onClick={() => { handleCancelFilter(); }}>Cancel</button>
                                </div>
                                <div className="col-8">
                                    <button className='apply' onClick={() => { handleApply(); }}>Apply</button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div>
                    <label>Sort By:</label>
                    <Select value={sortBy} onValueChange={(value) => {
                        setSortBy(value);
                        handleApply(value, sortOrder);
                    }}>
                        <SelectTrigger className="w-[10em]">
                            <SelectValue placeholder="Sort By" />
                        </SelectTrigger>
                        <SelectContent>
                            <SelectItem value="created_at">Generated</SelectItem>
                            <SelectItem value="date">Deadline</SelectItem>
                            <SelectItem value="priority">Priority</SelectItem>
                            <SelectItem value="title">Title (A-Z/Z-A)</SelectItem>
                            <SelectItem value="id">Task No</SelectItem>
                        </SelectContent>
                    </Select>
                </div>
                {/* Order */}
                <div>
                    <label>Order:</label>
                    <Select value={sortOrder} onValueChange={(value) => {
                        setSortOrder(value);
                        handleApply(sortBy, value);
                    }}>
                        <SelectTrigger className="w-[10em]">
                            <SelectValue placeholder="Order" />
                        </SelectTrigger>
                        <SelectContent>
                            <SelectItem value="desc">Descending</SelectItem>
                            <SelectItem value="asc">Ascending</SelectItem>
                        </SelectContent>
                    </Select>
                </div>
            </div>
            <div className="filters">
            {filterItem && filterItem.map((item, index) => (
                <div key={index} className="filter">
                    <span>{item.value}</span> 
                    <i onClick={() => deleteFilter(index)} className='fa-solid fa-xmark'></i>
                </div>
            ))}
            </div>

        </div>
    )
}



export default Filter
